import React, { Component } from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { throttle } from 'lodash';
import moment from 'moment';
import 'querystring'

/* subcomponents */
import AddBox from '@material-ui/icons/AddBox'
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';
import Checkbox from '@material-ui/core/Checkbox'

/* component styles */
import './styles.css';

const styles = "target_time"
const DEFAULT_ACTIVE_HOUR = true;
const DEFAULT_HOURS = new Array(24).fill(DEFAULT_ACTIVE_HOUR);
const DEFAULT_WEEK = new Array(7).fill(DEFAULT_HOURS);

export default class TargetTime extends Component<any, any> {
  static propTypes = {
    week: PropTypes.array,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    weekLyLabelType: PropTypes.bool,
  };

  public static defaultProps = {
    week: DEFAULT_WEEK,
    onChange: () => {},
    disabled: false,
  };

  cells: any;
  public state: any;
  public changeStateCellThrottle: any;

  constructor(props: any) {
    super(props);
    this.state = {
      week: this.getInitialStateWeek(props),
      isMouseDown: false,
      initialStateCell: null,
      bufferChangeCell: [],
      lastWeekElement: props.week.length,
    };
    this.changeStateCellThrottle = throttle(this.changeStateCell, 20);
    this.cells = [];
  }

  componentWillMount = () => {
    document.addEventListener('mouseup', this.handleMouseOut, false);
  };

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      week: this.getInitialStateWeek(nextProps),
    });
  }

  shouldComponentUpdate(nextProps: any, nextState: any) {
    return (nextState.week !== this.state.week);
  }

  componentWillUnmount = () => {
    document.removeEventListener('mouseup', this.handleMouseOut);
    this.changeStateCellThrottle.cancel();
  };

  getInitialStateWeek({ week = DEFAULT_WEEK }) {
    return this.localFormatWeek(week).map((day: any) => ({
      hours: [...day],
      isActive: day.some((hour: any) => hour === true),
    }));
  }

  setActiveHourDay(week: any, selectDay: any, selectHour: any, active: any) {
    return week.map((day: any, index: any) => {
      if (index === selectDay) {
        return {
          ...day,
          isActive: (!active) ? day.hours.some((hour: any, indexHour: any) => hour === true && indexHour !== selectHour) : true,
          hours: day.hours.map((hour: any, indexHour: any) => {
            if (indexHour === selectHour) {
              return active;
            }
            return hour;
          }),
        };
      }
      return day;
    });
  }

  getLocalDay(indexDay: any) {

    if(this.props.weekLyLabelType && this.props.weekLyLabelType === 2) {
      indexDay = indexDay < 6? indexDay + 1: 0;
    }

    return moment().weekday(indexDay).format('dddd');
    // return moment().weekday(indexDay).format('dd').toUpperCase();
  }

  localFormatWeek = (week: any, origin = false) => {
    const isoWeekStart = moment().isoWeekday(0);
    const localWeekStart = moment().weekday(0);
    const weekBegin = localWeekStart.day() - isoWeekStart.day();

    /* eslint-disable no-unreachable */
    switch (weekBegin) {
      case 1:
        return week;
        break;
      case 6:
        let saturday;

        if (origin) {
          saturday = week[0];
          week.splice(6, 0, saturday);
          week.shift();
          return week;
        }

        saturday = week.splice(5, 1).pop();
        week.unshift(saturday);
        return week;
        break;
      default:
        return week;
    }
  };

  handleMouseOut = () => {
    if (!this.state.isMouseDown) return;
    this.setState({ isMouseDown: false });
  };

  changeStateCell(selectDay: any, selectHour: any, selectCell: any) {
    const { initialStateCell, bufferChangeCell } = this.state;
    const cell = this.cells[selectCell];
    const containClassActive = cell.classList.contains(`${styles}__time-cell--active`);

    if (initialStateCell && !containClassActive) {
      cell.classList.add(`${styles}__time-cell--active`);
    } else if (initialStateCell === false && containClassActive) {
      cell.classList.remove(`${styles}__time-cell--active`);
    }

    bufferChangeCell.push({ day: selectDay, hour: selectHour });

    this.setState({
      bufferChangeCell,
    });
  }

  handleMouseDown = (selectDay: any, indexHour: any, selectCell: any, hour: any) => {
    this.changeStateCell(selectDay, indexHour, selectCell);
    this.setState({ isMouseDown: true, initialStateCell: !hour });
  };

  handleMouseEnter = (selectDay: any, indexHour: any, selectCell: any) => {
    const { isMouseDown } = this.state;

    if (!isMouseDown) return;
    this.changeStateCell(selectDay, indexHour, selectCell);
  };

  handleMouseUp = () => {
    const { initialStateCell, bufferChangeCell } = this.state;
    let { week } = this.state;
    bufferChangeCell.forEach((cell: any) => {
      week = this.setActiveHourDay(week, cell.day, cell.hour, initialStateCell);
    });

    this.setState({ isMouseDown: false, initialStateCell: null, week, bufferChangeCell: [] });
    this.props.onChange(this.localFormatWeek(week.map((day: any) => day.hours), true));
  };

  handleMouseMove = () => {
    const { initialStateCell, bufferChangeCell, isMouseDown } = this.state;
    if(!isMouseDown) return;
    let { week } = this.state;
    bufferChangeCell.forEach((cell: any) => {
      week = this.setActiveHourDay(week, cell.day, cell.hour, initialStateCell);
    });

    this.setState({ isMouseDown: false, initialStateCell: null, week, bufferChangeCell: [] });
    this.props.onChange(this.localFormatWeek(week.map((day: any) => day.hours), true));
  };

  changeStateHour = (selectHour: any, isActiveHour: any) => {
    const { week } = this.state;
    this.setState({
      week: week.map((currentDay: any) => ({
        ...currentDay,
        hours: currentDay.hours.map((hour: any, indexHour: any) => {
          if (indexHour === selectHour) {
            return !isActiveHour;
          }
          return hour;
        }),
      })),
    });
    this.props.onChange(
      this.localFormatWeek(
        week.map((currentDay: any) => (
          currentDay.hours.map((hour: any, indexHour: any) => {
            if (indexHour === selectHour) {
              return !isActiveHour;
            }
            return hour;
          })
        )),
        true
      )
    );
  };

  renderTimeCheckbox(text: any, selectHour: any) {
    const { week } = this.state;
    let isActiveHour: any, checked: any;

    isActiveHour = week.map((currentDay: any) => currentDay.hours.some((hour: any, indexHour: any) =>
      (indexHour === selectHour && hour === true)));
    isActiveHour = isActiveHour.some((hour: any )=> hour === true);
    checked = isActiveHour ? 'checked' : '';

    return (
    <label className={`${styles}__hour-checkbox`}>
      <Checkbox
        size="small"
        color="primary"
        checked={isActiveHour}
        onChange={() => this.changeStateHour(selectHour, isActiveHour)}
        disabled={this.props.disabled}/>
      <div>{text}</div>
    </label>
    );
  }

  renderDayCheckbox(selectIndexDay: any) {
    const changeStateDayTime = () => {
      const { week } = this.state;

      this.setState({
        week: week.map((currentDay: any, indexDay: any) => {
          if (indexDay === selectIndexDay) {
            const active = !currentDay.isActive;
            return {
              ...currentDay,
              isActive: active,
              hours: currentDay.hours.map(() => active),
            };
          }
          return currentDay;
        }),
      });

      this.props.onChange(
        this.localFormatWeek(
          week.map((currentDay: any, indexDay: any) => {
            if (indexDay === selectIndexDay) {
              const active = !currentDay.isActive;
              return currentDay.hours.map(() => active)
            }
            return currentDay.hours;
          }),
          false
        )
      );
    };

    return (
      <label className="label--checkbox">
        <Checkbox
          color="primary"
          size="small"
          checked={this.state.week[selectIndexDay].isActive}
          onChange={changeStateDayTime}
          disabled={this.props.disabled}/>
        <span>{this.getLocalDay(selectIndexDay)}</span>
      </label>
    );
  }

  renderToggle() {
    return (
      <div className={`${styles}__toggle`}>
        <div className={`${styles}__toggle__icon--active`}>
          <AddBox color="primary" fontSize="large"/>
        </div>
        <div className={`${styles}__toggle__icon--inactive`}>
          <IndeterminateCheckBoxIcon fontSize="large"/>
        </div>
      </div>
    );
  }

  renderTime(hours: any, selectDay: any, lastWeekElement = false) {
    return hours.map((hour: any, indexHour: any) => {
      let timeClass
      if (this.props.disabled) {
        timeClass = classNames(
          `${styles}__time-cell ${styles}__time-cell--disabled`,
          {
            [`${styles}__time-cell--active`]: hour,
            [`${styles}__time-cell__time-checkbox`]: lastWeekElement,
          }
        );
      } else {
        timeClass = classNames(
          `${styles}__time-cell`,
          {
            [`${styles}__time-cell--active`]: hour,
            [`${styles}__time-cell__time-checkbox`]: lastWeekElement,
          }
        );
      }
      const selectCell = `${selectDay} - ${indexHour}`;

      if (lastWeekElement) {
        const hourStart = moment().hour(indexHour).format('HH');
        // const hourEnd = moment().hour(indexHour).add(1, 'h').format('HH');
        // const label = `${hourStart} ${hourEnd}`;
        const label = `${hourStart}`;
        return (
          <td className={timeClass} key={`${indexHour}-last`}>
            {this.renderTimeCheckbox(label, indexHour)}
          </td>
        );
      }

      /* eslint no-return-assign: 0 */
      return (
        <td
          className={timeClass}
          ref={(cell) => this.cells[selectCell] = cell}
          key={indexHour}
          onMouseDown={() => this.handleMouseDown(selectDay, indexHour, selectCell, hour)}
          onMouseUp={() => this.handleMouseUp()}
          onMouseMove={() => this.handleMouseEnter(selectDay, indexHour, selectCell)}
        >
          {this.renderToggle()}
        </td>
      );
    });
  }

  renderGrid() {
    const { week } = this.state;
    const arrayWeek: any = [];
    const lastIndexWeek = week.length - 1;
    const dayClass = classNames(
      `${styles}__week-row`
    );

    week.forEach((day: any, indexDay: any) => {
      arrayWeek.push(
        <tr className={dayClass} key={indexDay}>
          <td className={`${styles}__day-checkbox`}
              onMouseMove={() => this.handleMouseMove()}
          >
            {this.renderDayCheckbox(indexDay)}
          </td>
          {this.renderTime(day.hours, indexDay)}
        </tr>
      );

      if (lastIndexWeek === indexDay) {
        arrayWeek.push(
          <tr className={dayClass} key={`${indexDay}-last`}
              onMouseMove={() => this.handleMouseMove()}
          >
            <td className={`${styles}__empty-checkbox`} />
            {this.renderTime(day.hours, indexDay, true)}
          </tr>
        );
      }
    });
    return arrayWeek;
  }

  render() {
    return (
      <table className={`${styles}`}
        onMouseLeave={() => this.handleMouseMove()}
      >
        <tbody>
        {this.renderGrid()}
        </tbody>
        <tfoot>
          <tr><td colSpan={25} align="center">Time</td></tr>
        </tfoot>
      </table>
    );
  }
}
